import { TypeCodeTranslation } from '../../shared.model';

export class ValueAndCauseDTO {
    valueBuildingBeforeAccident: number | '' = 0;
    valueContentBeforeAccident: number | '' = 0;
    damageCauseRemark: string = '';
    cloneInsuredAmountBuilding: number | '' = 0;
    cloneInsuredAmountContent: number | '' = 0;
    cloned: boolean = false;
}

export class CommunicationDTO {
    sendEmailToPolicyHolder: boolean = false;
    emailPolicyHolder: string = '';
    sendEmailToCounterExpert: boolean = false;
    emailCounterExpert: string = '';
    sendEmailToPersonalExpert: boolean = false;
    emailPersonalExpert: string = '';
    sendEmailToOther: boolean = false;
    emailOther: string = '';
    sendDaccaEmailToPolicyHolder: boolean = false;
    sendDaccaEmailToCounterExpert: boolean = false;
    sendDaccaEmailToPersonalExpert: boolean = false;
    sendDaccaEmailToOther: boolean = false;
    sent: boolean = false;
}

export class VatAndPaymentDTO {
    deductibleVatPercentage: number | '' = 0;
    vat6ToBeJustifiedAmount: number | '' = 0;
    vat21ToBeJustifiedAmount: number | '' = 0;
    financialAccountNumber: string = ''; // BBAN
    iban: string = '';
    bic: string = '';
}

export class CounterExpertiseDTO {
    nameTP: string = ''; // verhaaltov
    nameTPCompany: string = ''; // maatschappij
    referteTP: string = ''; // referte
    realValue: number | '' = 0;
    counterExpertSignedName: string = '';
    comment: string = '';
}

export class RemarkDTO {
    remark: string = '';
    remarksSelected: boolean = false;
}

export class SigningDTO {
    personalExpertSignedName: string = '';
    signatureCounterExpert: string = '';
    signaturePersonalExpert: string = '';
    signaturePolicyHolder: string = '';
    signatureExpertOrInspector: string = '';
    signedOn: string | undefined;
    cloneSuffererName: string = '';
    cloneSuffererLocation: string = '';
    reflectionTime: boolean = true;
}

export class SvsDTOLine {
    id: number = 0;
    amount: number = 0;
    description: string = '';
    lineFormatCode: string = '';
    sequence: number = 0;
    svsHeaderID: number = 0;
    deleted: boolean = false;
    isImportFromDacca: boolean = false;
}

export class SvsDTO {
    id: number = 0;

    valueAndCause: ValueAndCauseDTO = new ValueAndCauseDTO();
    communication: CommunicationDTO = new CommunicationDTO();
    vatAndPayment: VatAndPaymentDTO = new VatAndPaymentDTO();
    counterExpertise: CounterExpertiseDTO = new CounterExpertiseDTO();
    remark: RemarkDTO = new RemarkDTO();
    signing: SigningDTO = new SigningDTO();

    lines: SvsDTOLine[] = [];
    lineAmountTotal: number = 0;
    excessApplicableTC: string | undefined = undefined;
    underConditionTC: string | undefined = undefined;

    SVSApplicationOfTheExemptionTC: TypeCodeTranslation[] = [];
    SVSSubjectToTC: TypeCodeTranslation[] = [];

    // saved tab indicator
    tabLinesIsSaved: boolean = false;
    tabSigningIsSaved: boolean = false;
    tabRemarkIsSaved: boolean = false;
    tabCounterExpertiseIsSaved: boolean = false;
    tabVatAndPaymentIsSaved: boolean = false;
    tabCommunicationIsSaved: boolean = false;
    tabValueAndCauseIsSaved: boolean = false;

    locked: boolean = false;
    cloned: boolean = false;
    cloneSuffererName: string = '';
    cloneSuffererLocation: string = '';
    cloneInsuredAmountBuilding: string = '';
    cloneInsuredAmountContent: string = '';

    // for communication overview
    documentAmazonKey: string = '';
    daccaRikAmazonKey: string = '';
    createdOn: Date | '' = '';
    createdByName: string = '';
    createdByFirstName: string = '';
    createdByLastName: string = '';
    createdByCompany: string = '';
    createdByCompanyDibCode: string = '';
    approved?: boolean = false;

    reflectionTime: boolean = true;
}

export class SvsReportRequest {
    caseCode: string = '';
    svsHeaderIds: number[] = [];
}

export class SvsReportResponse {
    amazonKey: string = '';
    svsHeaderId: number = 0;
}

export class SvsAdditionalDTO {
    insuredPersonName: string = '';
    insuredAddress: string = '';
    policySubTypeTC: string = '';
    contractName: string = '';

    SVSApplicationOfTheExemptionTC: TypeCodeTranslation[] = [];
    SVSSubjectToTC: TypeCodeTranslation[] = [];
}
